export default __webpack_public_path__ + "resources/icons/d410-3bf8.png";